import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  decodeSerializableElement$default2o0k93vobxyld as decodeSerializableElement$default,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  Decoder23nde051s631g as Decoder,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance,
  InstantIso8601Serializer_getInstance2pw1uiz054ejd as InstantIso8601Serializer_getInstance,
  LocalTimeIso8601Serializer_getInstanceywsvdjhmwgt0 as LocalTimeIso8601Serializer_getInstance,
  LocalDateIso8601Serializer_getInstance3gidjo5oele30 as LocalDateIso8601Serializer_getInstance,
  LocalDateTimeIso8601Serializer_getInstance302qwxjrznnmc as LocalDateTimeIso8601Serializer_getInstance,
  DurationSerializer_getInstance3b3q4n80uazai as DurationSerializer_getInstance,
  DurationMsSerializer_getInstance132uar9zvq19v as DurationMsSerializer_getInstance,
} from './Serializers.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../UUID.js.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq as LocalTimeIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalTimeSerializers.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { LocalDateTimeIso8601Serializer_getInstance2em1n1hwy5urt as LocalDateTimeIso8601Serializer_getInstance_0 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateTimeSerializers.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { serializer37oyvz7rc4nep as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  ZonedDateTimeIso8601Serializer_getInstance3j594qymepbka as ZonedDateTimeIso8601Serializer_getInstance,
  ZonedDateTime2r72nac52vno4 as ZonedDateTime,
  OffsetDateTimeIso8601Serializer_getInstance3knxddo24n2p4 as OffsetDateTimeIso8601Serializer_getInstance,
  OffsetDateTime38eu0aw2k27kp as OffsetDateTime,
} from '../ZonedDateTime.mjs';
import { Companion_getInstance3qu5ydsg8audm as Companion_getInstance_2 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_getInstance3p275ab8rhrps as Companion_getInstance_3 } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/UtcOffset.mjs';
import { TimeZoneSerializer_getInstanceqa9aveo7y5x8 as TimeZoneSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/TimeZoneSerializers.mjs';
import {
  GeoCoordinateGeoJsonSerializer_getInstance27i54kiunnp5w as GeoCoordinateGeoJsonSerializer_getInstance,
  GeoCoordinatemhej4memzolm as GeoCoordinate,
  GeoCoordinateArraySerializer_getInstance1v36ss1z42d62 as GeoCoordinateArraySerializer_getInstance,
} from '../GeoCoordinate.mjs';
import { get_ClientModule2m5j3ywx3t162 as get_ClientModule } from './ClientModule.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultDecoder$json$delegate$lambda() {
  return Json(VOID, DefaultDecoder$json$delegate$lambda$lambda);
}
function DefaultDecoder$json$delegate$lambda$lambda($this$Json) {
  $this$Json.f29_1 = DefaultDecoder_getInstance().a4r_1;
  $this$Json.o28_1 = true;
  return Unit_instance;
}
var DefaultDecoder$beginStructure$1Class;
function DefaultDecoder$beginStructure$1() {
  if (DefaultDecoder$beginStructure$1Class === VOID) {
    class $ {
      constructor() {
        this.c4r_1 = -1;
      }
      mz() {
        return DefaultDecoder_getInstance().a4r_1;
      }
      n13(descriptor, index) {
        return false;
      }
      o13(descriptor, index) {
        return 0;
      }
      u13(descriptor, index) {
        return _Char___init__impl__6a9atx(32);
      }
      t13(descriptor, index) {
        return 0.0;
      }
      s13(descriptor, index) {
        return 0.0;
      }
      q13(descriptor, index) {
        return 0;
      }
      r13(descriptor, index) {
        return 0n;
      }
      p13(descriptor, index) {
        return 0;
      }
      v13(descriptor, index) {
        return '';
      }
      b14(descriptor) {
        $l$loop: while (true) {
          this.c4r_1 = this.c4r_1 + 1 | 0;
          if (this.c4r_1 >= descriptor.u11())
            return -1;
          if (!descriptor.z11(this.c4r_1))
            break $l$loop;
        }
        return this.c4r_1;
      }
      w13(descriptor, index) {
        return DefaultDecoder_getInstance();
      }
      z13(descriptor, index, deserializer, previousValue) {
        return null;
      }
      x13(descriptor, index, deserializer, previousValue) {
        var tmp0_safe_receiver = isInterface(deserializer, KSerializerWithDefault()) ? deserializer : null;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3m();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp1_safe_receiver == null) ? tmp1_safe_receiver : THROW_CCE();
        }
        var tmp2_safe_receiver = DefaultDecoder_getInstance().z4q_1.p3(deserializer.az().h10());
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp2_safe_receiver == null) ? tmp2_safe_receiver : THROW_CCE();
        }
        return deserializer.pz(DefaultDecoder_getInstance());
      }
      m13(descriptor) {
      }
    }
    protoOf($).y13 = decodeSerializableElement$default;
    protoOf($).a14 = decodeSequentially;
    protoOf($).c14 = decodeCollectionSize;
    initMetadataForClass($, VOID, VOID, VOID, [CompositeDecoder()]);
    DefaultDecoder$beginStructure$1Class = $;
  }
  return DefaultDecoder$beginStructure$1Class;
}
var DefaultDecoderClass;
function DefaultDecoder() {
  if (DefaultDecoderClass === VOID) {
    class $ {
      constructor() {
        DefaultDecoder_instance = this;
        this.z4q_1 = HashMap().n8();
        var tmp0 = this.z4q_1;
        var tmp2 = UUIDSerializer_getInstance().d4r_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value = Companion_getInstance().xw('00000000-0000-0000-0000-000000000000');
        tmp0.s3(tmp2, value);
        var tmp0_0 = this.z4q_1;
        var tmp2_0 = InstantIso8601Serializer_getInstance().e4r_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_0 = Companion_getInstance_0().q26(0n);
        tmp0_0.s3(tmp2_0, value_0);
        var tmp0_1 = this.z4q_1;
        var tmp2_1 = LocalTimeIso8601Serializer_getInstance().f4r_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_1 = LocalTime().b1x(0, 0, 0);
        tmp0_1.s3(tmp2_1, value_1);
        var tmp0_2 = this.z4q_1;
        var tmp2_2 = LocalDateIso8601Serializer_getInstance().g4r_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_2 = LocalDate().h1u(1970, 1, 1);
        tmp0_2.s3(tmp2_2, value_2);
        var tmp0_3 = this.z4q_1;
        var tmp2_3 = LocalDateTimeIso8601Serializer_getInstance().h4r_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_3 = LocalDateTime().u1w(LocalDate().h1u(1970, 1, 1), LocalTime().b1x(0, 0, 0));
        tmp0_3.s3(tmp2_3, value_3);
        var tmp0_4 = this.z4q_1;
        var tmp2_4 = InstantIso8601Serializer_getInstance_0().h25_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_4 = Companion_getInstance_0().q26(0n);
        tmp0_4.s3(tmp2_4, value_4);
        var tmp0_5 = this.z4q_1;
        var tmp2_5 = LocalTimeIso8601Serializer_getInstance_0().u25_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_5 = LocalTime().b1x(0, 0, 0);
        tmp0_5.s3(tmp2_5, value_5);
        var tmp0_6 = this.z4q_1;
        var tmp2_6 = LocalDateIso8601Serializer_getInstance_0().k25_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_6 = LocalDate().h1u(1970, 1, 1);
        tmp0_6.s3(tmp2_6, value_6);
        var tmp0_7 = this.z4q_1;
        var tmp2_7 = LocalDateTimeIso8601Serializer_getInstance_0().p25_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_7 = LocalDateTime().u1w(LocalDate().h1u(1970, 1, 1), LocalTime().b1x(0, 0, 0));
        tmp0_7.s3(tmp2_7, value_7);
        var tmp0_8 = this.z4q_1;
        var tmp2_8 = DurationSerializer_getInstance().i4r_1.h10();
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_1();
        var tmp$ret$9 = toDuration(0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.collections.set' call
        var value_8 = new (Duration())(tmp$ret$9);
        tmp0_8.s3(tmp2_8, value_8);
        var tmp0_9 = this.z4q_1;
        var tmp2_9 = serializer(Companion_getInstance_1()).az().h10();
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_1();
        var tmp$ret$11 = toDuration(0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.collections.set' call
        var value_9 = new (Duration())(tmp$ret$11);
        tmp0_9.s3(tmp2_9, value_9);
        var tmp0_10 = this.z4q_1;
        var tmp2_10 = DurationMsSerializer_getInstance().j4r_1.h10();
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_1();
        var tmp$ret$13 = toDuration(0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.collections.set' call
        var value_10 = new (Duration())(tmp$ret$13);
        tmp0_10.s3(tmp2_10, value_10);
        var tmp0_11 = this.z4q_1;
        var tmp2_11 = ZonedDateTimeIso8601Serializer_getInstance().b3o_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_11 = new (ZonedDateTime())(LocalDateTime().u1w(LocalDate().h1u(1970, 1, 1), LocalTime().b1x(0, 0, 0)), Companion_getInstance_2().c26_1);
        tmp0_11.s3(tmp2_11, value_11);
        var tmp0_12 = this.z4q_1;
        var tmp2_12 = OffsetDateTimeIso8601Serializer_getInstance().w3n_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_12 = new (OffsetDateTime())(LocalDateTime().u1w(LocalDate().h1u(1970, 1, 1), LocalTime().b1x(0, 0, 0)), Companion_getInstance_3().k26_1);
        tmp0_12.s3(tmp2_12, value_12);
        var tmp0_13 = this.z4q_1;
        var tmp2_13 = TimeZoneSerializer_getInstance().b26_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_13 = Companion_getInstance_2().q27();
        tmp0_13.s3(tmp2_13, value_13);
        var tmp0_14 = this.z4q_1;
        var tmp2_14 = GeoCoordinateGeoJsonSerializer_getInstance().h3m_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_14 = new (GeoCoordinate())(0.0, 0.0);
        tmp0_14.s3(tmp2_14, value_14);
        var tmp0_15 = this.z4q_1;
        var tmp2_15 = GeoCoordinateArraySerializer_getInstance().e3m_1.h10();
        // Inline function 'kotlin.collections.set' call
        var value_15 = new (GeoCoordinate())(0.0, 0.0);
        tmp0_15.s3(tmp2_15, value_15);
        this.a4r_1 = get_ClientModule();
        var tmp = this;
        tmp.b4r_1 = lazy(DefaultDecoder$json$delegate$lambda);
      }
      mz() {
        return this.a4r_1;
      }
      z12() {
        return false;
      }
      a13() {
        return 0;
      }
      g13() {
        return _Char___init__impl__6a9atx(32);
      }
      f13() {
        return 0.0;
      }
      e13() {
        return 0.0;
      }
      c13() {
        return 0;
      }
      d13() {
        return 0n;
      }
      b13() {
        return 0;
      }
      h13() {
        return '';
      }
      x12() {
        return true;
      }
      l13(descriptor) {
        return new (DefaultDecoder$beginStructure$1())();
      }
      qz(deserializer) {
        var tmp0_safe_receiver = isInterface(deserializer, KSerializerWithDefault()) ? deserializer : null;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3m();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp1_safe_receiver == null) ? tmp1_safe_receiver : THROW_CCE();
        }
        var tmp = this.z4q_1.p3(deserializer.az().h10());
        var tmp2_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : null;
        return tmp2_elvis_lhs == null ? deserializer.pz(this) : tmp2_elvis_lhs;
      }
      i13(enumDescriptor) {
        return 0;
      }
      j13(descriptor) {
        return this;
      }
      y12() {
        return null;
      }
    }
    initMetadataForObject($, 'DefaultDecoder', VOID, VOID, [Decoder()]);
    DefaultDecoderClass = $;
  }
  return DefaultDecoderClass;
}
var DefaultDecoder_instance;
function DefaultDecoder_getInstance() {
  if (DefaultDecoder_instance === VOID)
    new (DefaultDecoder())();
  return DefaultDecoder_instance;
}
function default_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KSerializerWithDefault()))
    return _this__u8e3s4.z3m();
  return DefaultDecoder_getInstance().qz(_this__u8e3s4);
}
var KSerializerWithDefaultClass;
function KSerializerWithDefault() {
  if (KSerializerWithDefaultClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KSerializerWithDefault', VOID, VOID, [KSerializer()]);
    KSerializerWithDefaultClass = $;
  }
  return KSerializerWithDefaultClass;
}
//region block: exports
export {
  DefaultDecoder as DefaultDecoder2zttto7bkrb7s,
  KSerializerWithDefault as KSerializerWithDefault194z2ragoko00,
  default_0 as default308h22k6ofhww,
  DefaultDecoder_getInstance as DefaultDecoder_getInstancezsiea2kgjp4b,
};
//endregion

//# sourceMappingURL=Defaults.mjs.map
